import { DataTableColumnHeader } from "components/ui/DataTable";
import { ColumnDef } from "@tanstack/react-table";
import {
  DataTableActions,
  IDataTableAction,
} from "components/ui/DataTableActions";

import { IHubDriver } from "interfaces/Hub";
import { usePermissions } from "hooks";
import { customMask } from "lib/customMask";

interface IColumnProps {
  deleteFunc: (toDelete: IHubDriver) => void;
}

export function useColumns({ deleteFunc }: IColumnProps) {
  const { checkUserPermission } = usePermissions();

  const columns: ColumnDef<IHubDriver>[] = [
    {
      id: "Id",
      accessorKey: "id",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Id" />
      ),
      cell: ({ row: { original: data } }) => {
        return `${data.id}`;
      },
      enableSorting: false,
      enableHiding: true,
    },

    {
      id: "cpf",
      accessorKey: "cpf",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="CPF" />
      ),
      cell: ({ row: { original: data } }) => {
        return customMask(`${data.document}`, "999.999.999-99");
      },
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: "phome",
      accessorKey: "phone",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Telefone" />
      ),
      cell: ({ row: { original: data } }) => {
        return data.phone_number;
      },
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: "name",
      accessorKey: "name",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Nome" />
      ),
      cell: ({ row: { original: data } }) => {
        return `${data.name}`;
      },
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: "carrier",
      accessorKey: "carrier",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Transportadora" />
      ),
      cell: ({ row: { original: data } }) => {
        return data.carriers.length ? data.carriers[0].company_name : "";
      },
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: "actions",
      cell: ({ row: { original: data } }) => {
        const actions: IDataTableAction[] = [
          {
            name: "Editar",
            route: `/settings/hub-drivers/edit/${data.id}`,
            hasPermission: checkUserPermission("all"),
          },
          {
            name: "Excluir",
            action: () => deleteFunc(data),
            hasPermission: checkUserPermission("all"),
          },
        ];
        return <DataTableActions actions={actions} />;
      },
    },
  ];

  return { columns };
}
